/**
 * Loads `fleet.json` — the one file that lives at the snapshot *root*
 * (sibling of every organism's own directory) rather than under a role.
 * Shape verified live against the real host on 2026-09-26
 * (https://futarchists.xyz/observatory/snapshots/fleet.json —
 * `src/types/incremental.ts`'s `FleetSnapshot`). Degrades to `null`, never
 * throwing, when it has not been published yet.
 */

import { snapshotUrl } from "../config";
import type { FleetSnapshot } from "../types/incremental";
import { fetchJsonWithEtag } from "../cache/httpCache";
import { isNotPublishedYet } from "./fetchJson";

export async function loadFleetSnapshot(): Promise<FleetSnapshot | null> {
  try {
    // fleet.json is one of the small mutable files (no-cache + ETag,
    // verified live) — poll it the same way as index.json/latest.json.
    return (await fetchJsonWithEtag<FleetSnapshot>(snapshotUrl("fleet.json"))).value;
  } catch (error) {
    if (isNotPublishedYet(error)) return null;
    throw error;
  }
}
